/*
 * @Description: 参与任务执行的性别分析
 * @Date: 2024-01-15 14:09:19
 */
import BiTmplDetail_4_2 from './bi-tmpl-detail-4-2.vue';
export default BiTmplDetail_4_2;
